module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAfCAMAAADdjm27AAAANlBMVEUAAAD////////////////////////////////////////////////////////////////////xY8b8AAAAEXRSTlMAApSjounZyoL10q6Nc2s1LE9cW60AAABFSURBVCjP3crLEcAgDANR4cRA/lH/zWbCCY8qgD2+WYSSbfmJspDcRegirCI2kuASwfFLTj3d7VqD2VR2QswhVhCrXt4P734KZ82in3gAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/pages/act/202010/unit_member/img/back-icon.png
// module id = 8T1C
// module chunks = 61